const AuthPlugin = {
  install(Vue) {
    // Token de sesión
    const token = () => localStorage.getItem('moverick-passenger-session-token')

    const setToken = newToken => {
      localStorage.setItem('moverick-passenger-session-token', newToken)
    }

    const removeToken = () => setToken('')

    /**
     * Elimina el token local y restablece en Vuex los datos vinculados a la sesión.
     */
    const resetLocalSession = () => {
      removeToken()
      Vue.store.dispatch('user/resetSessionState')
    }

    const setUser = user => {
      Vue.store.commit('setCurrentUser', user)
      Vue.store.dispatch('user/getAllClientData', null, {root: true})
    }

    const login = data => Vue.http.post('session', {data}, {localeRootKey: 'auth'})

    /**
     * Completa el cierre de sesión local y redirige a la página de inicio.
     */
    const finishLogout = () => {
      resetLocalSession()
      Vue.router.push({name: 'home'})
    }

    const logout = () => Vue.http.delete('session').then(finishLogout, finishLogout)

    const resetPassword = data => {
      const options = {localeRootKey: 'auth'}

      return Vue.http.post('clients/password', {data}, options).then(response => response.data)
    }

    const registration = data => Vue.http.post('clients', {data}).then(
      response => response.data.data
    )

    const unregister = params => Vue.http.delete('client', {params}).then(
      response => response.data.data
    )

    const update = (data, skipLoading = false) => {
      const options = {skipLoading, localeRootKey: 'auth'}

      return Vue.http.put('client', {data}, options).then(response => response.data.data)
    }

    const updatePassword = data => {
      const options = {localeRootKey: 'auth'}

      return Vue.http.put('client/update_password', {data}, options).then(
        response => response.data.data
      )
    }

    const confirmEmail = confirmationToken => Vue.http.put(
      'confirmation',
      null,
      {
        params: {confirmation_token: confirmationToken},
        skipError: true
      }
    )

    const resendConfirmation = email => Vue.http.post(
      'confirmations',
      {data: {email}}
    )

    const auth = {
      token,
      setToken,
      removeToken,
      resetLocalSession,
      setUser,
      login,
      logout,
      unregister,
      resetPassword,
      registration,
      update,
      updatePassword,
      confirmEmail,
      resendConfirmation
    }

    Vue.auth = auth
    Vue.prototype.$auth = auth
  }
}

Vue.use(AuthPlugin)
